module.exports = __webpack_public_path__ + "media/images/pic/banners/book-course-96961a173784299512b8b99ec2cccf87.svg";